import React, { useEffect } from "react";

import { AcceptancePage } from "@hubcapp/layouts";
import { Brand } from "@ds-developer/models";
import AcceptancePageResult from "./components/AcceptancePageResult";
type Props = {
  brand: string;
  agreementKey: string;
  result: string;
};

const AcceptancePageResultStateProvider: React.FC<Props> = ({
  brand,
  result,
  agreementKey,
}) => {
  useEffect(() => {
    if (brand === Brand.Bsm) {
      document.documentElement.style.setProperty("--brand-font", "Poppins");
    } else {
      document.documentElement.style.setProperty(
        "--brand-font",
        "New Transport AA",
      );
    }
  }, []);
  return (
    <AcceptancePage
      brand={brand === "BSM" ? Brand.Bsm : Brand.Aad}
      headerTitle="Thank you accepting your new franchise."
    >
      <AcceptancePageResult
        brand={brand}
        result={result}
        agreementKey={agreementKey}
      />
    </AcceptancePage>
  );
};

export default AcceptancePageResultStateProvider;
